module.exports = __webpack_public_path__ + "img/qrcode-android.d262a9bb.svg";